import { useCallback, useEffect } from 'react';

import { FetchStatus, Storage } from '../../enums';
import { IAccount } from '../../interfaces';
import { useDispatch, useSelector } from '../../utils';
import {
  editAccount,
  fetchAccount,
  fetchAccountFailed,
  resetAccount,
  resetAccountStatus,
  resetEditAccountStatus,
} from './actions';
import { selectAccount } from './selectors';

export const useAccount = () => useSelector(selectAccount);

export function useResetAccount() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetAccount());
  }, [dispatch]);
}

export function useResetAccountStatus() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetAccountStatus());
  }, [dispatch]);
}

export function useResetEditAccountStatus() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetEditAccountStatus());
  }, [dispatch]);
}

export function useFetchAccount() {
  const dispatch = useDispatch();
  const account = useAccount();
  const username = localStorage.getItem(Storage.USERNAME);

  useEffect(() => {
    if (!username) {
      dispatch(fetchAccountFailed({ error: 'Missing username' }));
    } else if (account.status.account === FetchStatus.IDLE) {
      dispatch(fetchAccount());
    }
  }, [username]);
}

export function useEditAccount() {
  const dispatch = useDispatch();

  return useCallback(
    (account: IAccount) => {
      dispatch(editAccount({ account }));
    },
    [dispatch],
  );
}
